module.exports = __webpack_public_path__ + "assets/c28ec9d2f948ccb77bf6eeedb04c4f35.mp3";